import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import LocationDropdown from './LocationDropdown';
import SearchBar from '../SearchBar';
import LoginText from '../LoginText';
import SideMenu from './SideMenu';

const Navbar = () => {
  const [selectedLocation, setSelectedLocation] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [isSideMenuVisible, setIsSideMenuVisible] = useState(false);
  const navigate = useNavigate();

  const handleSearch = () => {
    if (selectedLocation) {
      // Navigate to /explore with location and optional search term
      const path = searchTerm
        ? `/explore/${selectedLocation}/${searchTerm}`
        : `/explore/${selectedLocation}`;
      navigate(path);
    } else {
      alert('Please select a location');
    }
  };

  const toggleSideMenu = () => {
    setIsSideMenuVisible(!isSideMenuVisible);
  };

  return (
    <nav className="bg-white w-full py-2 fixed top-0 left-0 z-10 shadow-lg">
      <div className="w-full flex justify-between items-center px-2 md:px-8 lg:px-12">
        {/* Left Section: Logo */}
        <div className="flex items-center space-x-4">
          <Link
            to="/explore"
            className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 via-blue-600 to-indigo-600 text-xl md:text-2xl font-bold hover:text-indigo-600 transition-colors duration-300"
          >
            BookurSpot
          </Link>
          {/* Location and Search Bar */}
          <div className="flex items-center space-x-4">
            <LocationDropdown
              selectedLocation={selectedLocation}
              onChange={setSelectedLocation}
            />
            <SearchBar
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              onSearch={handleSearch}
            />
          </div>
        </div>

        {/* Right Section: Login/SideMenu */}
        <div className="flex items-center space-x-4 md:space-x-6">
          <LoginText toggleModal={toggleSideMenu} />
        </div>
      </div>
      <SideMenu isVisible={isSideMenuVisible} toggleSideMenu={toggleSideMenu} />
    </nav>
  );
};

export default Navbar;
